window.lp.pom = {};

window.lp.pom.context = {
  EDIT:0,
  PREVIEW:1,
  PUBLISH:2
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/pom/pom.js
// module id = 423
// module chunks = 0 1